<script setup lang="ts">
import GwBox from '@/components/lib/GwBox/GwBox.vue'
import GwText from '@/components/lib/base/GwText/GwText.vue'
import GwIcon from '@/components/lib/GwIcon/GwIcon.vue'
import { type TableOption } from '../../../../store/api/gql/hands/queries'

export interface STItemProps {
  item: TableOption
  active: boolean
}
defineProps<STItemProps>()
</script>
<template>
  <GwBox
    variant="box_active_outlined"
    :active
  >
    <GwIcon
      :icon="item.icon"
      variant="grey_transparent_auto"
      class="mb-auto"
    />
    <div class="f-column">
      <GwText variant="text_white_normal_700">
        {{ item.title }}
      </GwText>
      <GwText
        variant="text_grey_medium_400"
        style="max-width: 14rem"
        v-html="item.text"
      />
    </div>
  </GwBox>
</template>
